export default __webpack_public_path__ + "static/media/place_holder_Sales.155f800c.svg";